var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-content-information",class:{
    isPC: _vm.$store.getters['camera/isPC'],
    isI18nJa: _vm.$i18n.locale == 'ja',
    isI18nVi: _vm.$i18n.locale == 'vi',
    isI18nEn: _vm.$i18n.locale == 'en',
    isI18nId: _vm.$i18n.locale == 'id'
  }},[_vm._l((_vm.list),function(data,index1){return [_c('div',{key:index1,staticClass:"info-box"},[_c('div',{staticClass:"info-label"},[_vm._v(_vm._s(data.label))]),_c('div',{staticClass:"info-values"},_vm._l((data.values),function(value,index2){return _c('div',{key:index2,staticClass:"info-value"},[_vm._v(_vm._s(value))])}),0)])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }